__turbopack_context__.v({
  "caption": "card-module-scss-module__2FcOEW__caption",
  "cardContainer": "card-module-scss-module__2FcOEW__cardContainer",
  "cardContainerNoSwadow": "card-module-scss-module__2FcOEW__cardContainerNoSwadow",
  "cardContent": "card-module-scss-module__2FcOEW__cardContent",
  "cardContentZerocase": "card-module-scss-module__2FcOEW__cardContentZerocase",
  "cardHeader": "card-module-scss-module__2FcOEW__cardHeader",
  "cardHeaderActions": "card-module-scss-module__2FcOEW__cardHeaderActions",
  "cardHeaderTitle": "card-module-scss-module__2FcOEW__cardHeaderTitle",
  "cardHeaderTitleBrackets": "card-module-scss-module__2FcOEW__cardHeaderTitleBrackets",
  "cardInner": "card-module-scss-module__2FcOEW__cardInner",
  "cardInnerHorizontal": "card-module-scss-module__2FcOEW__cardInnerHorizontal",
  "cardInnerVertical": "card-module-scss-module__2FcOEW__cardInnerVertical",
  "label": "card-module-scss-module__2FcOEW__label",
});
